export default __webpack_public_path__ + "static/img-bigcoin-capital-427700a68d02a86487bce95e7145b80f.png";